import { ButtonTypes } from '@cox/core-ui8/dist/Button'

import { GOOGLE_MAP_ADDRESS_ENDPOINT } from '../../../../utils/inversion-util'
import ReactButton from '../../../ReactButton'
import ReactText from '../../../ReactText'
import './CommunityCard.scss'
import { ReactCommunityCardProps } from '../../types'

const CommunityCard = (props: ReactCommunityCardProps): JSX.Element => {
  const { community } = props
  const {
    property_name_display = '',
    address_line1 = '',
    address_line2 = '',
    address_city = '',
    address_state = '',
    address_zip = '',
    slug = ''
  } = community

  const getValue = (text: string, append?: string) => {
    if (text !== null) {
      return `${text}${append ? append : ''}`
    } else return ''
  }

  const address_line_2 = getValue(address_line2) == 'NULL' || getValue(address_line2) == null ? '' : getValue(address_line2)
  const address_line_3 = `${getValue(address_city, ', ')}${getValue(address_state, ', ')}${getValue(address_zip)}`
  const address = `${getValue(address_line1, ' ')}${getValue(address_line2, ' ')}${getValue(address_line_3)}`
  const GOOGLE_MAPS_API = `${GOOGLE_MAP_ADDRESS_ENDPOINT}${encodeURI(address)}`
  const currentPath = window.location.pathname.replace('.html', '/') ?? ''
  const COMMUNITY_ENDPOINT = `${currentPath}${slug}.html`

  return (
    <div className='community-card h-100'>
      <div className='community-card__body'>
        {property_name_display && (
          <ReactText text={property_name_display} className='community-card-body__title cox-text-heading4' isParsed />
        )}
        <div className='community-card__address'>
          {address_line1 && <ReactText text={address_line1} className='community-card__address-text' />}
          {address_line2 && <ReactText text={address_line_2} className='community-card__address-text' />}
          {address_line_3 && <ReactText text={address_line_3} className='community-card__address-text' />}
          <a className='community-card__address-link' href={GOOGLE_MAPS_API} target='_blank'>
            Get directions
          </a>
        </div>
      </div>
      <div className='community-card__footer'>
        <ReactButton
          className='community-card__footer-button'
          text={'View Community'}
          buttonTypes={ButtonTypes.PRIMARY}
          openInNewTab={false}
          linkUrl={COMMUNITY_ENDPOINT}
        />
      </div>
    </div>
  )
}
export default CommunityCard
